import React from 'react';
import { Card, Space, Divider } from 'antd';
import { 
    EnvironmentOutlined, 
    UserOutlined, 
    GlobalOutlined, 
    MessageOutlined, 
    ClockCircleOutlined 
} from '@ant-design/icons';
import { FlexBox, TextCommon } from '@esg/ui'; 

export interface BranchData {
    id: string; 
    branchName: string;
    fullName: string; 
    email: string;
    businessName: string;
    phoneNumber: string;
    mainBusinessCategory: string | string[]; 
    country: string;
    state: string;
    city: string;
    timeZone: string;
    postcode: string;
    branchAddress: string;
    appointmentTime: string; 
}

interface BranchProfileCardProps {
    branch: BranchData;
}

const BranchProfileCard: React.FC<BranchProfileCardProps> = ({ branch }) => {
    
    const formattedTime = branch.appointmentTime && branch.appointmentTime !== 'N/A' 
        ? new Date(branch.appointmentTime).toLocaleString() 
        : 'N/A';

    const categoriesArray = Array.isArray(branch.mainBusinessCategory) 
        ? branch.mainBusinessCategory 
        : [branch.mainBusinessCategory || 'General'];

    return (
        <Card 
            type="inner"
            title={
                <Space>
                    <EnvironmentOutlined style={{ color: '#1890ff' }} />
                    <TextCommon fontWeight={600}>{branch.branchName}</TextCommon>
                </Space>
            }
            style={{ 
                borderRadius: '8px', 
                height: '100%',
                border: '1px solid #f0f0f0',
                boxShadow: 'none'
            }}
            bodyStyle={{ padding: '12px' }} 
            headStyle={{ minHeight: '36px', padding: '0 12px' }}
        >
            <FlexBox direction="column" gap={10} flex="none" width="100%">
                
                {/* --- THE FIX: NEW CUSTOMER INFO SECTION --- */}
                <FlexBox direction="column" gap={10} width="100%">
                    <TextCommon color="#595959" fontWeight={600} fontSize={13}>
                        <UserOutlined /> Customer Info
                    </TextCommon>
                    
                    <FlexBox direction="row" gap={10} alignItems="center" width="100%">
                        <TextCommon color="#262626" fontWeight={500} fontSize={13} whiteSpace="nowrap"></TextCommon>
                        <TextCommon color="#595959" fontSize={13}>{branch.fullName}</TextCommon>
                    </FlexBox>

                    {/* <FlexBox direction="row" gap={4} alignItems="center" width="100%">
                        <TextCommon color="#262626" fontWeight={500} fontSize={13} whiteSpace="nowrap">Email:</TextCommon>
                        <TextCommon color="#595959" fontSize={13}>{branch.email}</TextCommon>
                    </FlexBox>

                    <FlexBox direction="row" gap={4} alignItems="center" width="100%">
                        <TextCommon color="#262626" fontWeight={500} fontSize={13} whiteSpace="nowrap">Phone:</TextCommon>
                        <TextCommon color="#595959" fontSize={13}>{branch.phoneNumber}</TextCommon>
                    </FlexBox> */}

                    {/* <FlexBox direction="row" gap={4} alignItems="center" width="100%">
                        <TextCommon color="#262626" fontWeight={500} fontSize={13} whiteSpace="nowrap">Customer ID:</TextCommon>
                        <TextCommon color="#8c8c8c" fontSize={12}>{cleanCustomerId}</TextCommon>
                    </FlexBox> */}
                </FlexBox>

                <Divider style={{ margin: '0' }} />

                <FlexBox direction="column" gap={10} width="100%">
                    <TextCommon color="#595959" fontWeight={600} fontSize={13}>
                        <MessageOutlined /> Enterprise Entity
                    </TextCommon>
                    <FlexBox direction="column" gap={10}>
                        <TextCommon fontWeight={600} color="#262626" fontSize={13}>{branch.businessName}</TextCommon>
                        <FlexBox direction="row" gap={6} flexWrap="wrap">
                            {categoriesArray.map((categoryItem: string, index: number) => (
                                <FlexBox 
                                    key={index}
                                    direction="row" 
                                    backgroundColor="#fff1f0" 
                                    padding="2px 6px" 
                                    borderRadius={4}
                                >
                                    <TextCommon color="#d9363e" fontSize={11} fontWeight={500}>
                                        {categoryItem}
                                    </TextCommon>
                                </FlexBox>
                            ))}
                        </FlexBox>
                    </FlexBox>
                </FlexBox>

                <Divider style={{ margin: '0' }} />

                <FlexBox direction="column" gap={10} width="100%">
                    <TextCommon color="#595959" fontWeight={600} fontSize={13}>
                        <GlobalOutlined /> Regional Metrics & Address
                    </TextCommon>
                    
                    <FlexBox direction="row" gap={12} flexWrap="wrap" width="100%">
                        <FlexBox direction="row" gap={10}>
                            <TextCommon color="#262626" fontWeight={600} fontSize={13}>Country:</TextCommon>
                            <TextCommon color="#595959" fontSize={13}>{branch.country}</TextCommon>
                        </FlexBox>
                        
                        <FlexBox direction="row" gap={10}>
                            <TextCommon color="#262626" fontWeight={600} fontSize={13}>TimeZone:</TextCommon>
                            <TextCommon color="#595959" fontSize={13}>{branch.timeZone}</TextCommon>
                        </FlexBox>
                        
                        <FlexBox direction="row" gap={10}>
                            <TextCommon color="#262626" fontWeight={600} fontSize={13}>State/City:</TextCommon>
                            <TextCommon color="#595959" fontSize={13}>{branch.state}, {branch.city}</TextCommon>
                        </FlexBox>
                        
                        <FlexBox direction="row" gap={10}>
                            <TextCommon color="#262626" fontWeight={600} fontSize={13}>Postcode:</TextCommon>
                            <TextCommon color="#595959" fontSize={13}>{branch.postcode}</TextCommon>
                        </FlexBox>
                    </FlexBox>

                    <FlexBox direction="column" gap={2} width="100%">
                        <TextCommon color="#8c8c8c" fontSize={12}>
                            Physical Address:
                        </TextCommon>
                        <TextCommon color="#595959" fontSize={13} lineHeight={1.3}>
                            {branch.branchAddress}
                        </TextCommon>
                    </FlexBox>
                </FlexBox>

                <FlexBox 
                    direction="row"
                    alignItems="center"
                    padding="4px 8px"
                    backgroundColor="#e6f7ff"
                    borderRadius={4}
                    border="1px solid #91d5ff"
                >
                    <Space size={4}>
                        <ClockCircleOutlined style={{ color: '#1890ff', fontSize: '13px' }} />
                        <TextCommon color="#096dd9" fontWeight={600} fontSize={13}>Appointment :</TextCommon> 
                        <TextCommon color="#096dd9" fontWeight={500} fontSize={13}>{formattedTime}</TextCommon>
                    </Space>
                </FlexBox>

            </FlexBox>
        </Card>
    );
};

export { BranchProfileCard };